import React, { FC } from 'react';
import { StyleProps } from 'src/lib/styleProps';
import { useActiveCourseCategoryFilter } from 'src/public/components/course-page/hooks/useActiveCourseCategoryFilter';
import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { typography } from 'src/config/typography';
import { media } from 'src/config/breakpoints';
import { searchHeadingId } from 'src/config/listing';

const ListingTitle = styled.div`
  color: ${colors.red};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375rem;

  ${media.w.min.px576(css`
    font-size: 1.5rem;
    line-height: 1.875rem;
  `)};

  ${media.w.min.px992(css`
    font-size: 2.3125rem;
    line-height: 2.875rem;
  `)};
`;

export const CourseListingHeading: FC<StyleProps> = (styleProps) => {
  const data = useActiveCourseCategoryFilter();

  return (
    <ListingTitle id={searchHeadingId} {...styleProps}>
      {data.length === 1 ? data[0].title : 'Wybrane kategorie'}
    </ListingTitle>
  );
};
